export default __webpack_public_path__ + "static/media/twitter.4735b615.svg";